import React from "react";
import { OrderStatus } from "../../../../../../../../Interfaces/formValue-interfaces";
import useLanguagesHooks from "../../../../../../../../Components/Languages/setLanguage-hooks";
import styles from "./orderStatusBadge.module.scss";

interface OrderStatusBadgeProps {
  status: OrderStatus;
  onClick?: () => void;
}

const statusConfig: Record<
  OrderStatus,
  { gradient: string; color: string; }
> = {
  [OrderStatus.NEW]: {
    gradient: "linear-gradient(135deg, #ff512f, #dd2476)",
    color: "#fff",
  },
  [OrderStatus.PENDING]: {
    gradient: "linear-gradient(135deg, #f7971e, #ffd200)",
    color: "#fff",
  },
  [OrderStatus.ACCEPTED]: {
    gradient: "linear-gradient(135deg, #11998e, #38ef7d)",
    color: "#fff",
  },
  [OrderStatus.REJECTED]: {
    gradient: "linear-gradient(135deg, #cb2d3e, #ef473a)",
    color: "#fff",
  },
  [OrderStatus.IN_PREPARATION]: {
    gradient: "linear-gradient(135deg, #7b4397, #dc2430)",
    color: "#fff",
  },
  [OrderStatus.READY_FOR_PICKUP]: {
    gradient: "linear-gradient(135deg, #00c6ff, #0072ff)",
    color: "#fff",
  },
  [OrderStatus.OUT_FOR_DELIVERY]: {
    gradient: "linear-gradient(135deg, #1e3c72, #2a5298)",
    color: "#fff",
  },
  [OrderStatus.DELIVERED]: {
    gradient: "linear-gradient(135deg, #56ab2f, #a8e063)",
    color: "#fff",
  },
  [OrderStatus.CANCELLED]: {
    gradient: "linear-gradient(135deg, #606c88, #3f4c6b)",
    color: "#fff",
  },
};

export const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status, onClick }) => {
  const { t } = useLanguagesHooks();
  const { gradient, color } = statusConfig[status];
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClick) onClick();
  };

  return (
    <div
      className={styles.statusBadge}
      style={{
        background: gradient,
        color,
      }}
      onClick={onClick ? handleClick : undefined}
    >
      <span>{status === OrderStatus.NEW ? t(`My_Business.OrderStatus.New`) : t(`My_Business.OrderStatus.${status}`)}</span>
    </div>
  );
};
